import React from 'react'
// import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import IconTitle from 'components/IconTitle';
import AICollegeList from '../elements/AICollegeList';
import Discount from '../elements/Discount';

import vw from 'styles/utils';
import media from 'styles/media';

import aiCollege from 'data/aiCollege';

function AICollege(props) {
	return (
		<Root>
			<IconTitle
				title="人工智慧學院"
				iconImage={require('assets/images/icons/iconoir_light-bulb-on.png')}
			/>
			<Row>
				<Col>
					<AICollegeList
						articles={aiCollege}
					/>
				</Col>
				<Col>
					<Discount />
				</Col>
			</Row>
		</Root>
	)
}

AICollege.propTypes = {}

const Root = styled.section`
`;

const Row = styled.div`
  display: flex;
	flex-direction: column;
  /* border-bottom: 1px solid #DADADA; */

  ${vw('padding-bottom', 8, 15)}
  ${vw('margin-bottom', 8, 15)}
	${vw('column-gap', 8, 20, 24)}

	@media ${media.desktop} {
    flex-direction: row;
  }

  > img {
    width: auto;
    height: auto;

    ${vw('max-width', 12, 18)}
    ${vw('max-height', 12, 18)}
  }
`;

const Col = styled.div`
	width: 100%;

	@media ${media.desktop} {
    width: 50%;
  }
`;

export default AICollege
